import { Box, Typography } from '@mui/material';
import ButtonTheme from '../../../components/ThemeButton/ThemeButton';
import {
  syncStationsWithV3,
  syncStationUnitsWithV3,
} from '../../../functions/stationsAndUnitsApi';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { stationsAndUnitsThunk } from '../../../store/stationsAndUnitsReducer/thunk';

export const Header = ({ title }) => {
  const dispatch = useDispatch();
  const syncUnitsOnClick = async () => {
    try {
      await syncStationUnitsWithV3();
      toast.success('Units synced successfully');
      dispatch(stationsAndUnitsThunk.getAllUnitsThunk({}));
    } catch (error) {
      toast.error('Failed to sync units');
      console.error(error);
    }
  };

  const syncStationsOnClick = async () => {
    try {
      await syncStationsWithV3();
      toast.success('Stations synced successfully');
    } catch (error) {
      toast.error('Failed to sync stations');
      console.error(error);
    }
  };
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '32px' }}>
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <ButtonTheme
          onClick={syncUnitsOnClick}
          variant="filled"
          color="primary"
          sx={{
            px: 3,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 600,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-1px)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          Sync Units
        </ButtonTheme>
        <ButtonTheme
          variant="filled"
          color="primary"
          sx={{
            px: 3,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 600,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-1px)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
          onClick={syncStationsOnClick}
        >
          Sync Station
        </ButtonTheme>
      </Box>
    </Box>
  );
};
